import { render, staticRenderFns } from "./RevenueTypeForm.vue?vue&type=template&id=b3a406a0&"
import script from "./RevenueTypeForm.vue?vue&type=script&lang=js&"
export * from "./RevenueTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports